import { AppData } from "../../../types";
import { ShowNonModalDialogPayload } from "../../../actions";

export type ShowNonModalDialogOptions = {
  appData: AppData;
  payload: ShowNonModalDialogPayload;
};

export function showNonModalDialog({
  appData,
  payload,
}: ShowNonModalDialogOptions): AppData {
  const { variant } = payload;
  return { ...appData, nonModalDialog: variant };
}
